import cp from "./cp.png"
import portfolio from "./portfolio.jpg"
import word from "./wordofday.png"
export default [
    {
        title:"Competitive Programming",
        thumbnail:cp,
        url:"https://www.codechef.com/users/mdadnan123",
        desc:"I am pretty much active on sites like codechef and codeforces to improve my skills in competitive coding."
    },
    {
        title:"Portfolio website",
        thumbnail:portfolio,
        url:"https://portfolio-p6dx.onrender.com/",
        desc:"This is my portfolio website created using ReactJS. ReactJS is a JavaScript library to create single page web applications."
    },
    {
        title:"Word of the day",
        thumbnail:word,
        url:"https://github.com/MohammadAdnan123/Word-of-the-day",
        desc:"This python program will fetch the word of the day and give a notification when run. You can put it in task scheduler for every day update."
    }
]